import React from 'react';
import { FaEye, FaPen } from 'react-icons/fa';
import './PermissionTableCard.css';

const PermissionsSectionHeader = ({ theme }) => (
  <div className={`permissions-intro ${theme === 'dark' ? 'permissions-intro--dark' : ''}`}>
    <div>
      <h5 className="permissions-intro__title">Autorizações de acesso</h5>
      <p className="permissions-intro__text">
        Marcar <strong>Editar</strong> habilita <strong>Ver</strong> automaticamente.
      </p>
    </div>
    <div className="permissions-intro__legend">
      <span><FaEye /> Ver</span>
      <span><FaPen /> Editar</span>
    </div>
  </div>
);

export default PermissionsSectionHeader;
